/* The mockup's `.sec` "Actividad del mes": a heading with its meta, then three tiles. */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-3);
}

.title {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.meta {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

/* "Exportar CSV" (owner 2026-10-19) at the end of the head. */
.actions {
  margin-inline-start: auto;
}

.tiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

@media (max-width: 767.98px) {
  .tiles {
    grid-template-columns: minmax(0, 1fr);
  }
}

.tile {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-4);
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.label {
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.value {
  font-size: var(--font-size-32);
  font-variant-numeric: tabular-nums;
  font-weight: var(--font-weight-semibold);
  line-height: 1.2;
}
